import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

const isTokenExpired = () => {
  const expiresAt = localStorage.getItem('expires_at');
  return new Date() > new Date(expiresAt);
};

const ProtectedRoute = () => {
  const isLoggedIn = localStorage.getItem('access_token') && isTokenExpired();
  return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
